module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_12.f9c77771.jpg";